var AdobeAnalytics = {};

AdobeAnalytics.cookieConsentGiven = false;

AdobeAnalytics.queue = [];

AdobeAnalytics.initialize = function () {
  if (!window.hasOwnProperty("AA_data")) {
    window.AA_data = {}; //Adobe Analytics data
  }
  window.AA_data["vendor"] = sessionStorage.getItem("channel");
  window.AA_data["editor-name"] = "Prints Editor";
  window.AA_data["editor-version"] = "Prints Editor #{Octopus.Release.Number}"; //Will be dynamically replaced by webpack build process
  window.AA_data["product-category"] = "Prints";
};

AdobeAnalytics.setCookieConsent = function (cookieConsentGiven) {
  this.cookieConsentGiven = cookieConsentGiven;
  if (this.cookieConsentGiven && window._satellite) {
    this.queue.forEach((element) => {
      this.track(element["action"], element["data"]);
    });
    this.queue = [];
  }
};

AdobeAnalytics.setImportPhotosPage = function () {
  this.track("editor-create");
};

AdobeAnalytics.photosImportedFromPhotoOrganiser = function (numberOfPhotos) {
  this.track("editor-upload-photos", { "number-of-photos": numberOfPhotos });
};

AdobeAnalytics.photosImportedFromDevice = function (numberOfPhotos) {
  this.track("editor-upload-photos", { "number-of-photos": numberOfPhotos });
};

AdobeAnalytics.setEditPhotosPage = function () {
  this.track("editor-prints-options");
};

AdobeAnalytics.setUpsellPage = function () {
  this.track("editor-prints-extras");
};

AdobeAnalytics.setFinished = function () {
  this.track("editor-add-to-basket");
};

AdobeAnalytics.setRedirectingToCart = function () {
  this.track("editor-redirect-to-basket");
};

AdobeAnalytics.setLowResAndAutoCropWarnings = function (warningList) {
  if (warningList.length > 0) {
    warningList.forEach((warning) => {
      this.track("editor-warning", { warning: warning });
    });
  } else {
    window.AA_data["warnings"] = "No Warnings";
  }
};

AdobeAnalytics.track = function (action, data) {
  if (this.cookieConsentGiven && window._satellite) {
    if (data != undefined) {
      window._satellite.track(action, data);
    } else {
      window._satellite.track(action, {});
    }
  } else {
    this.queue.push({
      action: action,
      data: data,
    });
  }
};

export default AdobeAnalytics;
